import FaqDetailPage from './FaqDetailPage';

export default FaqDetailPage;
